import { oc } from '@orpc/contract';
import { z } from 'zod';
import { success } from '../common/success.dto';
import { connectErrorbody, connectRequestBody } from './pnr.dto';

export const pnrContract = {
  connect: oc
    .route({
      method: 'POST',
      path: '/pnr/connect/auth',
      summary: 'Connect to PNR service',
    })
    .input(connectRequestBody)
    .output(success)
    .errors({
      CONNECT_ERROR_401: {
        status: 401,
        data: connectErrorbody,
      },
      CONNECT_ERROR_400: {
        status: 400,
        data: connectErrorbody,
      },
      BAD_REQUEST: {
        status: 400,
        data: z.object({ message: z.string() }),
      },
    }),
};

export default pnrContract;
